import { lazy, Suspense } from 'react';
import App from './App';
import HomeComponent from './pages/Home';
import ProductComponent from './pages/Product';
import BlogComponent from './pages/Blog';
import BlogPostComponent from './pages/BlogPost';
import ContactComponent from './pages/Contact';
import MaintenanceKolamRenang from './pages/seo/MaintenanceKolamRenang';
import JualChemicalPool from './pages/seo/JualChemicalPool';
import PasangFilterKolam from './pages/seo/PasangFilterKolam';
import TestkitWaterPool from './pages/seo/TestkitWaterPool';
import EquipmentPool from './pages/seo/EquipmentPool';
import ExpertAdvice from './pages/seo/ExpertAdvice';
import PerawatanKolamUbud from './pages/seo/PerawatanKolamUbud';
import PoolMaintenanceBali from './pages/seo/PoolMaintenanceBali';
import Spinner from './components/Spinner';
import { baseBlogPost } from './constant/blogPosts';

const BuildPoolComponent = lazy(() => import('./pages/pool'));
const PoolCalculator = lazy(() => import('./pages/pool/PoolCalculator'));
const BalancingTank = lazy(() => import('./pages/pool/DesignBalancingTank'));
const DynamicShape = lazy(() => import('./pages/pool/OpenCVPoolCalculator'));
const LogComponent = lazy(() => import('./pages/pool/Log'));
const DiagramComponent = lazy(() => import('./pages/pool/PoolDiagram'));
const EstimateCeramicComponent = lazy(() => import('./pages/pool/EstimateCeramic'));

const wrap = (Component) => (
  <Suspense fallback={<Spinner />}>
    <Component />
  </Suspense>
);

export const routes = [
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <HomeComponent /> },
      { path: '/product', element: <ProductComponent /> },
      { path: '/blog', element: <BlogComponent /> },
      {
        path: '/blog/:slug',
        element: <BlogPostComponent />,
        getStaticPaths: () => baseBlogPost.map((p) => `/blog/${p.slug}`),
      },
      { path: '/contact', element: <ContactComponent /> },
      {
        path: '/pool',
        element: wrap(BuildPoolComponent),
        children: [
          { path: '/pool/calculator', element: wrap(PoolCalculator) },
          { path: '/pool/ceramic', element: wrap(EstimateCeramicComponent) },
          { path: '/pool/balancing-tank', element: wrap(BalancingTank) },
          { path: '/pool/dynamic-shape', element: wrap(DynamicShape) },
          { path: '/pool/log', element: wrap(LogComponent) },
          { path: '/pool/diagram', element: wrap(DiagramComponent) },
        ],
      },
      {
        path: '/jasa-maintenance-kolam-renang-bali',
        element: <MaintenanceKolamRenang />,
      },
      { path: '/jual-chemical-pool-bali', element: <JualChemicalPool /> },
      {
        path: '/pasang-filter-kolam-renang-bali',
        element: <PasangFilterKolam />,
      },
      { path: '/jasa-testkit-air-kolam-bali', element: <TestkitWaterPool /> },
      { path: '/equipment-pool-bali', element: <EquipmentPool /> },
      { path: '/konsultasi-kolam-renang-bali', element: <ExpertAdvice /> },
      {
        path: '/jasa-perawatan-kolam-renang-ubud',
        element: <PerawatanKolamUbud />,
      },
      {
        path: '/pool-maintenance-bali',
        element: <PoolMaintenanceBali />,
      },
    ],
  },
];
